import React, { useEffect, useState } from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
// import MapToggleButton from './MapToggleButton';
import FarmName from './FarmName';
import QuickSearch from './QuickSearch';
import Notification from '../../widgets/Notification';
import ProfileMenu from './ProfileMenu';
import PlanTypeSelection from './PlanTypeSelection';
import { usePermission } from "../../../helpers/common";
import { getFarmSettings } from '../../../actions/farm';

const Header = ({ children }) => {
	const allow = usePermission();
	const [show, setShow] = useState(false);
	const dispatch = useDispatch();

	const isAllowMap = allow("map", "view");
	const { uiConfig: { logoUrl, isLogoVisible, isOrganizationVisible, isFarmVisible, organizationFontSize,
		organizationFontWeight, organizationFontFamily }, organizationName } = useSelector(state => state.organization);
	const headingStyle = () => ({
		fontSize: organizationFontSize,
		fontWeight: organizationFontWeight,
		fontFamily: organizationFontFamily,
	});
	const { farm_uuid: farmId, farm_name: farmName } = useSelector(state => state.farm.currentFarm);
	const planTypeId = useSelector(state => state.plan.selectedPlanType);

	/* useEffect(() => {
			triggerNavigator({ name: "geolocation", label: "Location" });
	}, []) */
	useEffect(() => {
		dispatch(getFarmSettings({ farm_uuid: farmId, plan_type_id: planTypeId }));
	}, [farmId, planTypeId]);
	return (
		<>
			<div className="main-header">
				<Navbar expand="sm">
					<div className="main-header__left">
						<Button variant="link" className="menu-style">
							<i className="fa fa-bars" title={farmName}></i>
						</Button>
						{isLogoVisible && (
							<span>
								<NavLink to={`/home/farm/${farmId}/map`} className='navbar-brand'>
									<img src={logoUrl} alt="" />
								</NavLink>
							</span>
						)}

						{isOrganizationVisible && (<span>
							<h6 style={headingStyle()} className="org-info" >
								{organizationName}
							</h6 >
						</span>
						)}

						{isFarmVisible && <FarmName />}
					</div>
					{isAllowMap && <div className="quick-search-dropdown" >< QuickSearch /></div>}
					<div className="main-header__right">
						<div className="nav-bar-action header-menu notification-dropdown" >
							{children}
						</div>
						{/* <MapToggleButton /> */}
						<PlanTypeSelection />
						<ProfileMenu showNotificationSetting={() => setShow(!show)} />
					</div>
				</Navbar>
			</div>
			{show && <Notification show={show} farmId={farmId} onHide={() => setShow(false)} />}
		</>
	);
};

export default Header;